import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_USE_DONATION_LANGUAGE = createFcmDetails('use_donation_language', {
	owner: 'Payments',
	context: 'Payment forms',
	description: 'Whether or not to use copy that refers to transactions as donations',
	import: false,
});
